import { Button } from "@blueprintjs/core";
import SingleFormInput from "components/SingleFormInput";
import { selectResetUserRequest, selectResetUserError, resetUser, selectResetUser } from "controllers/user/action";
import { debounce, isEmpty } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Analytics } from "utils/analytics";
import { validate } from "utils/form";
import VerifyCode from "./VerifyCode";

export default function SendCode() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [toVerifyCode, setToVerifyCode] = useState(false);

  const dispatch = useDispatch();
  const request = useSelector(selectResetUserRequest);
  const success = useSelector(selectResetUser);
  const apiError = useSelector(selectResetUserError);

  useEffect(() => {
    Analytics.getInstance().event("Send Code", "Opened");
    return () => {};
  }, []);

  useEffect(() => {
    if (!isEmpty(success) && request?.email === email) {
      setToVerifyCode(true);
    }
  }, [success, request, email]);

  const debounceField = debounce(({ name, value }) => {
    const { isValid, getMessage } = validate(name);
    if (!isValid(value, [])) {
      setError(getMessage(value, []) as string);
    } else {
      setError("");
    }
  }, Number(process.env.REACT_APP_DEBOUNCE));

  const handleChange = (event: any) => {
    event.preventDefault();
    const { name, value } = event.target;
    setEmail(value);
    debounceField({ name, value });
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const { isValid, getMessage } = validate("email");
    if (!error && isValid(email, [])) {
      dispatch(resetUser({ email: email }));
    } else {
      setError(getMessage(email, []) as string);
    }
  };

  if (toVerifyCode) {
    return <VerifyCode email={email} />;
  } else {
    return (
      <form onSubmit={handleSubmit}>
        {apiError && request?.email === email ? <p className="red helperText">{apiError.error}</p> : ""}
        <p>A reset verification code will be sent to email entered below</p>
        <SingleFormInput
          name="email"
          type="email"
          label="Email"
          value={email}
          error={error}
          handleChange={handleChange}
        />
        <div className="form__footer">
          <div></div>
          <Button
            className="button-submit"
            intent="primary"
            disabled={!isEmpty(error) || (!isEmpty(apiError) && request?.email === email)}
            type="submit"
            text="Send Verification Code"
          />
        </div>
      </form>
    );
  }
}
